

































































import { Prop } from "vue-property-decorator";
import Component, { mixins } from "vue-class-component";
import { InputPaymentSystemUpdate, PaymentSystem } from "@teacherskaya/api-provider/dist/api/PaymentSystemsProvider";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import WithPaymentSystems from "@/mixins/WithPaymentSystems";
import { FormFields, FormValues } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import { CheckAuthorities } from "@/lib/helpers/componentViewController/decorators";
import { isDraftPaymentSystem, isTestPaymentSystem } from "@/lib/helpers/paymentSystems";
import PaymentSystemMixin from "@/views/PageSettingsPaymentSystems/mixins/PaymentSystemMixin";
import BlockBaseView from "@/components/BlockBaseView.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import BaseLabel from "@/components/BaseLabel.vue";
import BlockBase from "@/components/BlockBase.vue";

@Component({
  name: "BlockPaymentSystem",
  components: {
    BaseLabel,
    BlockBaseView,
    BlockBaseForm,
    BlockBase,
    ModalConfirm,
  },
})
export default class BlockPaymentSystem extends mixins(WithPaymentSystems, PaymentSystemMixin) {
  @Prop({ type: Object, required: true })
  public readonly paymentSystem!: PaymentSystem;

  @Prop({ required: true })
  public readonly currencyList!: Currency[];

  @Prop({ default: true })
  public readonly needUpgrade!: boolean;

  public editing: boolean = false;

  public showConfirm: boolean = false;

  @CheckAuthorities("PaymentSystem", "update_any")
  public hasAuthorities!: boolean;

  public get allowEdit() {
    return this.hasAuthorities || this.needUpgrade;
  }

  get title(): string {
    if (this.isTestSystem) {
      return $t("{0} Test Payment System", [$t(this.getPaymentSystemInfo(this.paymentSystem.type).name)]);
    }
    return $t(!this.isDraft ? `Payment system: {0}` : `Payment system: {0} (draft)`, [
      $t(this.getPaymentSystemInfo(this.paymentSystem.type).name),
    ]);
  }

  get isDraft() {
    return isDraftPaymentSystem(this.paymentSystem);
  }

  get isTestSystem() {
    return isTestPaymentSystem(this.paymentSystem);
  }

  get fields(): FormFields {
    const fields = this.fieldsBuilder(this.paymentSystem.type, this.paymentSystem.active, 1, this.currencyList);
    return fields.map(item => {
      if (item.value === undefined && item.name !== "currencies") {
        item.value = this.paymentSystem.details[item.name] || null;
      } else if (item.name === "currencies") item.value = this.paymentSystem.currencies;
      return item;
    });
  }

  public save(values: FormValues) {
    const data: InputPaymentSystemUpdate = {
      active: values.active ? values.active : false,
      id: this.paymentSystem.id,
      details: this.getDetails(values),
      currencies: values.currencies,
    };
    if (this.paymentSystem.type === "stripe") delete data.details.webhookSecretKey;
    this.paymentSystemsUpdate({ data }).then(() => {
      this.editing = false;
    });
  }

  public deleteItem() {
    const id = this.paymentSystem.id;
    this.paymentSystemsDeleteSystem({ id });
  }

  public cancel() {
    this.editing = false;
  }
}
